import React from 'react';
import PropTypes from 'prop-types';

import { getAssetFilePath } from '../../products/summary/common/get_asset_file_path';

const SergeiShocked = ({ className, imgSrc }) => {
    return (
        <picture><img className={className} alt={'Oops'} src={getAssetFilePath(imgSrc)} /></picture>
    );
};

SergeiShocked.propTypes = {
    className: PropTypes.string,
    imgSrc: PropTypes.string.isRequired
};

export { SergeiShocked };
